export function reorder(array, target, newOrder) {
    return array.sort(function (a, b) {
        var _a, _b, _c;
        var diff = ((_a = target.order) !== null && _a !== void 0 ? _a : 0) - newOrder;
        var currentOrderA = (_b = a.order) !== null && _b !== void 0 ? _b : 0;
        if (a.id === target.id) {
            currentOrderA = newOrder - 1;
        }
        else if (currentOrderA <= newOrder && diff > 0) {
            currentOrderA--;
        }
        var currentOrderB = (_c = b.order) !== null && _c !== void 0 ? _c : 0;
        if (b.id === target.id) {
            currentOrderB = newOrder + 1;
        }
        else if (currentOrderB >= newOrder && diff < 0) {
            currentOrderB++;
        }
        return currentOrderA - currentOrderB;
    });
}
